import React from 'react';
import { Link } from 'react-router-dom';
import { Calendar, User, ArrowRight } from 'lucide-react';

const ArticlesList = () => {
  const articles = [
    {
      id: 1,
      slug: 'pure-kashmiri-kesar-clinically-proven-elixir',
      title: 'Pure Kashmiri Kesar: A Clinically Proven Elixir of Wellness',
      excerpt: 'For centuries, kesar (saffron) has occupied a revered place in Ayurveda as a rasayana — a rejuvenating substance that nourishes the body, mind, and spirit.',
      image: 'https://images.unsplash.com/photo-1760982685244-17a1814ab806',
      date: 'December 2024',
      author: 'Hind Harvest Team'
    },
    {
      id: 2,
      slug: 'kashmir-where-kesar-is-guarded',
      title: 'Kashmir: Where Kesar Is Not Grown, but Guarded',
      excerpt: 'High in the Himalayas, where the air is thin, the soil is ancient, and time moves gently, lies Kashmir — a land long celebrated for beauty, poetry, and purity.',
      image: 'https://images.unsplash.com/photo-1750579909774-ff40e6e1ca62',
      date: 'December 2024',
      author: 'Hind Harvest Team'
    }
  ];

  return (
    <div className="pt-20">
      {/* Header Section */}
      <section className="bg-gradient-to-br from-saffron-50 to-cream-100 py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <h1 className="text-5xl font-bold text-gray-900 mb-4">Articles & Resources</h1>
            <p className="text-xl text-gray-600 max-w-2xl mx-auto">
              Discover insights, tips, and stories about premium FMCG products and traditional Indian agriculture.
            </p>
          </div>
        </div>
      </section>

      {/* Articles Grid */}
      <section className="py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {articles.map((article) => (
              <Link
                key={article.id}
                to={`/articles/${article.slug}`}
                className="bg-white rounded-2xl overflow-hidden shadow-sm hover:shadow-xl transition-all duration-300 hover:-translate-y-2 group"
              >
                {/* Article Image */}
                <div className="h-64 overflow-hidden">
                  <img
                    src={article.image}
                    alt={article.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                  />
                </div>

                {/* Article Content */}
                <div className="p-6">
                  {/* Meta Information */}
                  <div className="flex items-center gap-4 text-sm text-gray-500 mb-4">
                    <div className="flex items-center gap-2">
                      <Calendar size={14} />
                      <span>{article.date}</span>
                    </div>
                    <div className="flex items-center gap-2">
                      <User size={14} />
                      <span>{article.author}</span>
                    </div>
                  </div>

                  {/* Title */}
                  <h2 className="text-2xl font-bold text-gray-900 mb-3 group-hover:text-saffron-600 transition-colors duration-200">
                    {article.title}
                  </h2>

                  {/* Excerpt */}
                  <p className="text-gray-600 leading-relaxed mb-4">
                    {article.excerpt}
                  </p>

                  {/* Read More */}
                  <div className="flex items-center text-saffron-600 font-semibold group-hover:text-saffron-700">
                    Read Article
                    <ArrowRight className="ml-2 group-hover:translate-x-1 transition-transform duration-200" size={20} />
                  </div>
                </div>
              </Link>
            ))}
          </div>

          {/* More Articles Coming Soon */}
          <div className="mt-12 bg-gradient-to-br from-saffron-50 to-cream-100 rounded-2xl p-8 text-center">
            <p className="text-lg font-semibold text-gray-900 mb-2">More Articles Coming Soon</p>
            <p className="text-gray-600">
              Stay tuned for more insightful articles about traditional farming practices, health benefits, recipes, and India's rich agricultural heritage.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ArticlesList;
